import { createRouter, createWebHistory } from 'vue-router'
// import routes from './routes'

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			name: 'home-page',
			component: () => import('../views/Home-Page.vue')
		}, {
			path: '/about',
			name: 'about-page',
			component: () => import('../views/About-Page.vue'),
			props: { isDarkmode: true }
		}, {
			path: '/works',
			name: 'work-page',
			component: () => import('../views/Works-Page.vue'),
			children:[{
				path: '',
				name: 'work-list-page',
				component: () => import('../views/Works-List-Page.vue'),
			},{
				path: 'starx',
				name: 'starx-page',
				component: () => import('../views/works/Works-Starx.vue')
			},{
				path: 'bipsee-corporate',
				name: 'bipsee-corporate-page',
				component: () => import('../views/works/Works-BipseeCorp.vue')
			},{
				path: 'bipsee-logo',
				name: 'bipsee-logo-page',
				component: () => import('../views/works/Works-BipseeLogo.vue')
			},{
				path: 'xrclinic',
				name: 'xrclinic-page',
				component: () => import('../views/works/Works-XRclinic.vue')
			},{
				path: 'liteview',
				name: 'liteview-page',
				component: () => import('../views/works/Works-Liteview.vue')
			},{
				path: 'techpit',
				name: 'techpit-page',
				component: () => import('../views/works/Works-Techpit.vue')
			},{
				path: 'goodfind',
				name: 'goodfind-page',
				component: () => import('../views/works/Works-Goodfind.vue')
			},{
				path: 'goodfind-news',
				name: 'goodfind-news-page',
				component: () => import('../views/works/Works-GoodfindNews.vue')
			},{
				path: 'goodfind-magazine',
				name: 'goodfind-magazine-page',
				component: () => import('../views/works/Works-GoodfindMagazine.vue')
			}]
		},{
			path: '/sandbox',
			name: 'sandbox-page',
			component: () => import('../views/Sandbox-Page.vue')
		}
	],
	scrollBehavior() {
		return {
			top: 0
		}
	}
})

router.beforeEach((to, from, next) => {
  if (document.startViewTransition) {
    document.startViewTransition(() => next());
  } else {
    next();
  }
});

export default router;
